// Show/hide institution form
(function ($) {
	
	var $typeInput = $('input[name="type"]');
	var $institutionP = $('p.institution');

	$typeInput.on('change', function () {
		if( $typeInput.eq(1).prop('checked') ) $institutionP.addClass('shown');
		else $institutionP.removeClass('shown');
	});

})(jQuery);

// Addresss autofill
document.getElementById('post2').addEventListener('keyup', function () {
			AjaxZip3.zip2addr('post1','post2','prefecture','city');
		}, false);

// Fee calculator
var unitInput = document.getElementById('unitInput');
var feeInput = document.getElementById('feeInput');
var unitSpan = document.getElementById('unitSpan');
var feeSpan = document.getElementById('feeSpan');

unitInput.addEventListener('change', function (e) {
	var unitNum = unitInput.value;
	var fee = (3000 * unitNum).toLocaleString('en-US');

	unitSpan.innerHTML = unitNum;
	feeSpan.innerHTML = fee;
	feeInput.value = fee;
});

// Redirection after "submit"
var redirectTargetInput = document.getElementById('redirectTarget');
var redirectTarget = redirectTargetInput.value;
console.log(redirectTarget);

document.addEventListener( 'wpcf7mailsent', function( event ) {
  location = '/membership' + redirectTarget;
}, false );